/* eslint-disable react/button-has-type */
import React from 'react'
import { classNames } from 'core/helpers/misc'
import { Link } from 'core/components/route'

function handleClick(ev, onClick) {
	if (!!onClick && typeof onClick !== 'string') {
		ev.preventDefault()
		onClick(ev.target)
	}
}

function renderContent(loading, title, icon) {
	if (loading) {
		return (
			<>
				<span
					aria-hidden="true"
					className="spinner-border spinner-border-sm"
					role="status"
				/>
				<span className="sr-only">Carregando...</span>
			</>
		)
	}

	return (
		<>
			{!!icon && <i aria-hidden="true" className={icon} />}
			{!!title && <span>{title}</span>}
		</>
	)
}

export const Button = ({
	type = 'submit',
	loading = false,
	onClick,
	customClassName,
	icon,
	title,
	className = 'btn',
	disabled,
}) => {
	const buttonClassName = classNames(className, customClassName)

	return typeof onClick === 'string' ? (
		<Link className={buttonClassName} to={onClick}>
			{renderContent(loading, title, icon)}
		</Link>
	) : (
		<button
			className={buttonClassName}
			disabled={disabled}
			onClick={ev => handleClick(ev, onClick)}
			type={type}
		>
			{renderContent(loading, title, icon)}
		</button>
	)
}
